/**
 * Creates a function that takes the first argument as a string, removes
 * a prefix from it and feeds it forward into the provided function.
 *
 * The use case for this function is to allow multiple <RadioGroup/>
 * elements for options with overlapping value types. Without prefixing
 * them only the first <RadioGroup /> element will work properly.
 *
 * Example:
 * ```
 * const fakeCallback = jest.fn();
 * const stripFn = stripPrefix("test.", fakeCallback);
 * stripFn("test.mcTestFace");
 * // This assertion passes
 * expect(fakeCallback).toHaveBeenCalledWith("mcTestFace");
 * ```
 */
export function stripPrefix<
  TPrefix extends string,
  TValue extends string,
  TResult
>(prefix: TPrefix, target: (value: TValue) => TResult) {
  return (prefixedValue: `${TPrefix}${TValue}`) => {
    // @ts-expect-error - This _should_ work based off the template literal type but... 🤷
    const actualValue: TValue = prefixedValue.slice(prefix.length);
    target(actualValue);
  };
}
